
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6FXhW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $b07d8c9d22f2f251$export$3550862aa0bdc052 = (0, $cozmU.createContext)(new Map());
function $b07d8c9d22f2f251$export$83879714422b787c() {
    return (0, $cozmU.useContext)($b07d8c9d22f2f251$export$3550862aa0bdc052);
}
const $b07d8c9d22f2f251$export$a68c7a9725dc53e4 = (0, $cozmU.createContext)(new Map());
module.exports["AgentSessionsContext"] = $b07d8c9d22f2f251$export$3550862aa0bdc052;
module.exports["useAgentSessionsContext"] = $b07d8c9d22f2f251$export$83879714422b787c;
module.exports["CommentAgentConversationsContext"] = $b07d8c9d22f2f251$export$a68c7a9725dc53e4;

});

parcelRegister("dMwtT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

// Retain tab-local submission state across comment popup remounts, without treating it as success.
const $34223059cd0fd16b$var$submitted = new Map();
const $34223059cd0fd16b$var$listeners = new Set();
const $34223059cd0fd16b$var$subscribe = (listener)=>{
    $34223059cd0fd16b$var$listeners.add(listener);
    return ()=>{
        $34223059cd0fd16b$var$listeners.delete(listener);
    };
};
const $34223059cd0fd16b$export$c145943deb110dba = (conversationId)=>$34223059cd0fd16b$var$submitted.get(conversationId);
function $34223059cd0fd16b$export$dbb55a1fea1a3cbe(conversationId, invocationId, state = {
    status: 'resolved'
}, replyMatch) {
    $34223059cd0fd16b$var$submitted.delete(conversationId);
    if (invocationId) $34223059cd0fd16b$var$submitted.set(conversationId, {
        invocationId: invocationId,
        state: state,
        replyMatch: replyMatch
    });
    if ($34223059cd0fd16b$var$submitted.size > 100) $34223059cd0fd16b$var$submitted.delete($34223059cd0fd16b$var$submitted.keys().next().value);
    $34223059cd0fd16b$var$listeners.forEach((listener)=>listener());
}
function $34223059cd0fd16b$export$b28245959de0d67(conversationId) {
    const subscribeToConversation = (0, $cozmU.useCallback)((listener)=>conversationId ? $34223059cd0fd16b$var$subscribe(listener) : ()=>{}, [
        conversationId
    ]);
    return (0, $cozmU.useSyncExternalStore)(subscribeToConversation, ()=>$34223059cd0fd16b$var$submitted.get(conversationId), ()=>undefined);
}
module.exports["getSubmittedCommentAgentAction"] = $34223059cd0fd16b$export$c145943deb110dba;
module.exports["setSubmittedCommentAgentAction"] = $34223059cd0fd16b$export$dbb55a1fea1a3cbe;
module.exports["useSubmittedCommentAgentAction"] = $34223059cd0fd16b$export$b28245959de0d67;

});

parcelRegister("mzXSs", function(module, exports) {

var $9ljjX = parcelRequire("9ljjX");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $2VSIF = parcelRequire("2VSIF");


var $fD0Uz = parcelRequire("fD0Uz");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $4ywyi = parcelRequire("4ywyi");


var $ldZ32 = parcelRequire("ldZ32");


var $3a1bc = parcelRequire("3a1bc");


var $iKgqM = parcelRequire("iKgqM");


var $9vz83 = parcelRequire("9vz83");


var $dMwtT = parcelRequire("dMwtT");


var $gXKuh = parcelRequire("gXKuh");

/**
 * Live status subscription for a single comment's agent conversation.
 *
 * This is an *observe-only* channel: it streams session-status updates for the given
 * conversation without competing with the conversation's own message stream (owned by the
 * open CwR sidebar right after a mention) — which is what made a direct POST to the chat
 * `message/stream/sse` endpoint unreliable for freshly-mentioned agents.
 *
 * The union member's `__typename` drives our ConversationState:
 *   - ConvoAiTraceMessage                                  → WORKING
 *   - ConvoAiConversationMessage (state COMPLETED)         → hidden
 *   - ConvoAiConversationMessage (state CANCELLED)         → hidden (experiment on)
 *   - ConvoAiConversationMessage (state FAILED)            → FAILED
 *   - ConvoAiConversationMessage (ASSISTANT, has actions)  → INPUT_REQUIRED
 *   - ConvoAiConversationMessage (ASSISTANT, no actions)   → ARTEFACT_READY
 *   - ConvoAiErrorMessage                                  → FAILED
 *   - ConvoAiEmptyConversation / other                     → ignored
 *
 * Modelled on jira-ai/agent-stack-unconnected's AgentSessionStatusSubscription. Defined inline
 * (not a separate module) per graphql-relay-compat/no-import-relay-graphql-operations.
 */ const $738882cc71046357$var$CommentAgentSessionStatusSubscription = (0, $9ljjX.default);
// Snapshot states for which the agent's turn has genuinely ended, so there is nothing left to
// stream — we surface the snapshot directly and skip opening a live subscription (a perf win on
// page load, where most sessions are already settled).
//
// INPUT_REQUIRED is deliberately excluded: it is NOT terminal — it means the agent is paused
// waiting for the user. When the user replies (via the Rovo sidebar) the conversation resumes
// with fresh WORKING → ARTEFACT_READY messages, so the subscription must stay open to receive
// them. Treating it as terminal would freeze the badge on "Waiting for your input" for the
// rest of the session.
const $738882cc71046357$var$TERMINAL_STATES = new Set([
    'ARTEFACT_READY',
    'FAILED'
]);
const $738882cc71046357$var$COMPLETION_GRACE_MS = 500;
function $738882cc71046357$var$getSafeErrorMessageTemplate(value) {
    switch(value){
        case 'A2A_ERROR':
        case 'ACCEPTABLE_USE_VIOLATIONS':
        case 'ERROR':
        case 'PRE_EXECUTION_ERROR':
            return value;
        default:
            return undefined;
    }
}
/**
 * Fires an outcome event for an observed agent session state from the query snapshot,
 * subscription, or polling.
 * INPUT_REQUIRED, ARTEFACT_READY and COMPLETED count as success; FAILED counts as failure.
 * WORKING and CANCELLED are ignored. Success does not require the user to post the reply.
 *
 * Only ConvoAiErrorMessage supplies error details; polling provides a state without a message.
 * Callers apply the experiment gate and reject stale or locally cancelled updates.
 * Callers deduplicate success per conversation within the mounted hook; failures are not deduplicated.
 */ function $738882cc71046357$var$fireCommentAgentSessionOutcomeEvent(createAnalyticsEvent, state, observationSource, message, contentType, duration, isDefaultAgent) {
    if (state === 'WORKING' || state === 'CANCELLED') return;
    // A response awaiting user input counts as success, even before its action is completed.
    const action = state === 'FAILED' ? 'failed' : 'succeeded';
    const failureMessage = action === 'failed' && message?.__typename === 'ConvoAiErrorMessage' ? message : undefined;
    try {
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: action,
                actionSubject: 'commentAgentSessionReply',
                source: 'agentMention',
                attributes: action === 'failed' ? {
                    ...contentType ? {
                        contentType: contentType
                    } : {},
                    outcomeState: state,
                    observationSource: observationSource,
                    ...duration !== undefined ? {
                        duration: duration
                    } : {},
                    ...isDefaultAgent !== undefined ? {
                        isDefaultAgent: isDefaultAgent
                    } : {},
                    statusCode: failureMessage?.statusCode,
                    errorMessageTemplate: $738882cc71046357$var$getSafeErrorMessageTemplate(failureMessage?.errorMessageTemplate)
                } : {
                    ...contentType ? {
                        contentType: contentType
                    } : {},
                    outcomeState: state,
                    observationSource: observationSource,
                    ...duration !== undefined ? {
                        duration: duration
                    } : {},
                    ...isDefaultAgent !== undefined ? {
                        isDefaultAgent: isDefaultAgent
                    } : {}
                }
            }
        }).fire();
    } catch  {
    // Analytics must not interrupt the agent session or its status UI.
    }
}
/**
 * Maps a single `convoai_onAgentSessionUpdate` message to a stream state, or null when the
 * message carries no status signal (and should be ignored). COMPLETED is kept as an internal
 * sentinel so the public state can become null and remove the status row.
 *
 * Only explicit backend failure signals map to FAILED — either a failed agent session state or
 * a ConvoAiErrorMessage. Transport/connection problems are handled by the subscription layer
 * and never surface as a (false) chat failure here.
 */ function $738882cc71046357$var$mapMessageToState(message) {
    switch(message?.__typename){
        case 'ConvoAiTraceMessage':
            return 'WORKING';
        case 'ConvoAiConversationMessage':
            if (message.agentSessionState === 'CANCELLED' && (0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true)) return 'CANCELLED';
            if (message.agentSessionState === 'COMPLETED' || message.agentSessionState === 'FAILED') return message.agentSessionState;
            // Only assistant messages reflect non-terminal agent progress.
            if (message.role !== 'ASSISTANT') return null;
            // Pending actions mean the user has to respond; otherwise the result is ready.
            return message.actions && message.actions.length > 0 ? 'INPUT_REQUIRED' : 'ARTEFACT_READY';
        case 'ConvoAiErrorMessage':
            return 'FAILED';
        default:
            // ConvoAiEmptyConversation and any future/unknown member: no status change.
            return null;
    }
}
function $738882cc71046357$export$88d2b52896d57f4(commentId, conversationId, initialState, contentType) {
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const replyTiming = (0, $cozmU.useRef)();
    // Capture the invocation time before optimistic discovery clears it. Never time a
    // loaded session from mount: that would understate the latency of its reply.
    (0, $cozmU.useEffect)(()=>{
        if ((0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true)) {
            const session = (0, $4ywyi.getOptimisticCommentAgentSessionMetrics)(commentId);
            const previous = replyTiming.current?.commentId === commentId && (!replyTiming.current.conversationId || replyTiming.current.conversationId === conversationId) ? replyTiming.current : undefined;
            replyTiming.current = {
                commentId: commentId,
                conversationId: conversationId,
                startedAt: session?.startedAt ?? previous?.startedAt,
                isDefaultAgent: session?.isDefaultAgent ?? previous?.isDefaultAgent
            };
        }
    }, [
        commentId,
        conversationId
    ]);
    const isLocallyCancelled = (0, $2VSIF.useIsConversationCancelled)((0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true) ? conversationId ?? '' : '');
    const isStarting = (0, $4ywyi.useOptimisticCommentAgentSession)((0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true) ? commentId : '', !!conversationId || !!initialState);
    // Deduplicate observations, independently of optimistic discovery. This resets on remount.
    const reportedSuccessConversationIds = (0, $cozmU.useRef)(new Set());
    const handleSessionOutcome = (0, $cozmU.useCallback)((next, observationSource, message)=>{
        if (next === 'WORKING') return;
        if (next === 'CANCELLED') {
            replyTiming.current = undefined;
            return;
        }
        if (next !== 'FAILED') {
            if (!conversationId || reportedSuccessConversationIds.current.has(conversationId)) return;
            // Mark before firing so repeated subscription/poll updates cannot send success again.
            reportedSuccessConversationIds.current.add(conversationId);
        }
        const startedAt = replyTiming.current?.startedAt;
        if (replyTiming.current) replyTiming.current.startedAt = undefined;
        $738882cc71046357$var$fireCommentAgentSessionOutcomeEvent(createAnalyticsEvent, next, observationSource, message, contentType, // Milliseconds from local invocation to the first observed reply outcome.
        startedAt !== undefined ? Date.now() - startedAt : undefined, replyTiming.current?.isDefaultAgent);
    }, [
        conversationId,
        createAnalyticsEvent,
        contentType
    ]);
    const previousQuerySnapshot = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        const previous = previousQuerySnapshot.current;
        previousQuerySnapshot.current = {
            conversationId: conversationId,
            state: initialState
        };
        // The page-level query can observe the outcome before the subscription or poll does. Only
        // report a transition for the same conversation; an already-settled initial snapshot may
        // have been loaded during a page refresh and must not be counted as a new response.
        if (conversationId && previous?.conversationId === conversationId && previous.state !== initialState && initialState && initialState !== 'WORKING' && !isLocallyCancelled && (0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true)) handleSessionOutcome(initialState, 'querySnapshot');
    }, [
        conversationId,
        initialState,
        isLocallyCancelled,
        handleSessionOutcome
    ]);
    // Live status observed from the subscription. null until a message arrives. We never set
    // this from a transport/connection error — only explicit backend failure signals map to
    // FAILED — so a transient blip is never mistaken for a failed chat.
    const [streamState, setStreamState] = (0, $cozmU.useState)(null);
    const subscriptionRevision = (0, $cozmU.useRef)(0);
    const completionTimer = (0, $cozmU.useRef)(undefined);
    const completionPending = (0, $cozmU.useRef)(false);
    const pollingScope = (0, $cozmU.useContext)((0, $3a1bc.AgentSessionPollingContext));
    // Reset observed state when the conversation changes, so a comment never briefly shows a
    // previous conversation's status.
    (0, $cozmU.useEffect)(()=>{
        subscriptionRevision.current += 1;
        clearTimeout(completionTimer.current);
        completionPending.current = false;
        setStreamState(null);
        return ()=>{
            clearTimeout(completionTimer.current);
            subscriptionRevision.current += 1;
            completionPending.current = false;
        };
    }, [
        conversationId
    ]);
    // Stopping in Chat is local to the conversation. Drop any prior live status so a later
    // user-initiated turn can resume from fresh subscription data after the cancellation clears.
    (0, $cozmU.useEffect)(()=>{
        if (isLocallyCancelled) {
            replyTiming.current = undefined;
            subscriptionRevision.current += 1;
            clearTimeout(completionTimer.current);
            completionPending.current = false;
            setStreamState(null);
        }
    }, [
        isLocallyCancelled
    ]);
    // Skip the subscription when there is nothing to observe, or when the backend snapshot is
    // already terminal (the agent finished in a prior session — show the snapshot directly).
    const snapshotIsTerminal = !!initialState && $738882cc71046357$var$TERMINAL_STATES.has(initialState);
    // A delayed query must not close a subscription that has reported newer work.
    const skip = !cloudId || !conversationId || snapshotIsTerminal && (!(0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true) || streamState !== 'WORKING' && streamState !== 'INPUT_REQUIRED');
    function recoverFromSubscriptionFailure() {
        if (skip || isLocallyCancelled || completionPending.current || streamState === 'CANCELLED' || streamState === 'COMPLETED' || streamState && $738882cc71046357$var$TERMINAL_STATES.has(streamState) || !(0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true)) return;
        // Drop stale live status until live updates resume. Preserve a terminal message even
        // when it arrived in the same React batch as the transport completion.
        setStreamState((current)=>current === 'CANCELLED' || current === 'COMPLETED' || current && $738882cc71046357$var$TERMINAL_STATES.has(current) ? current : null);
        window.dispatchEvent(new Event((0, $gXKuh.AGENT_SESSION_SUBSCRIPTION_FAILED_EVENT)));
    }
    const subscription = (0, $fD0Uz.useSubscriptionInterop)($738882cc71046357$var$CommentAgentSessionStatusSubscription, {
        skip: skip,
        variables: {
            cloudId: cloudId ?? '',
            conversationId: conversationId ?? ''
        },
        interopApolloAggClient: true,
        onSubscriptionData: ({ subscriptionData: subscriptionData })=>{
            const message = subscriptionData.data?.convoai_onAgentSessionUpdate;
            const next = $738882cc71046357$var$mapMessageToState(message);
            if (next && !isLocallyCancelled) {
                const revision = ++subscriptionRevision.current;
                clearTimeout(completionTimer.current);
                completionPending.current = false;
                if (next === 'COMPLETED' && conversationId && pollingScope && (0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true)) {
                    // A tool can complete while the conversation is still working. Allow a subsequent
                    // stream update to win before querying the authoritative session state.
                    completionPending.current = true;
                    completionTimer.current = setTimeout(()=>{
                        completionTimer.current = undefined;
                        (0, $9vz83.fetchCommentAgentSessionState)(pollingScope.environment, pollingScope.pageId, conversationId).then((snapshot)=>{
                            if (subscriptionRevision.current !== revision) return;
                            completionPending.current = false;
                            if (snapshot) {
                                handleSessionOutcome(snapshot, 'subscription');
                                setStreamState(snapshot);
                            }
                        }, ()=>{
                            if (subscriptionRevision.current === revision) completionPending.current = false;
                        });
                    }, $738882cc71046357$var$COMPLETION_GRACE_MS);
                } else {
                    if ((0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true)) handleSessionOutcome(next, 'subscription', message);
                    setStreamState(next);
                }
            }
        },
        ...(0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true) ? {
            onSubscriptionComplete: recoverFromSubscriptionFailure
        } : {},
        __callerPackage__: "agent-mention"
    });
    (0, $cozmU.useEffect)(()=>{
        // The subscription hook exposes errors as results, so recovery follows that external update.
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        if (subscription?.error) recoverFromSubscriptionFailure();
    // An unchanged error must not discard live messages received after recovery.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscription?.error,
        conversationId
    ]);
    // Prefer the live subscription status, fall back to the backend snapshot, and finally to
    // WORKING while a conversation exists but has not reported a status yet. A completed session
    // returns null so consumers remove its status row.
    const state = streamState === 'CANCELLED' || streamState === 'COMPLETED' ? null : streamState ?? initialState ?? (conversationId ? 'WORKING' : null);
    const onPollRequest = (0, $cozmU.useCallback)(()=>{
        const revision = subscriptionRevision.current;
        return (snapshot)=>{
            const next = conversationId ? snapshot.get(conversationId) : undefined;
            if (next && subscriptionRevision.current === revision) {
                if ((0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true)) handleSessionOutcome(next, 'polling');
                setStreamState(next);
            }
        };
    }, [
        conversationId,
        handleSessionOutcome
    ]);
    const pollingEnabled = !!cloudId && !!conversationId && !isLocallyCancelled && (state === 'WORKING' || state === 'INPUT_REQUIRED') && (0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true);
    const submission = (0, $dMwtT.useSubmittedCommentAgentAction)((0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true) ? conversationId ?? '' : '');
    // Keep submission progress or recovery visible until comments have been reconciled.
    const hasPendingSubmission = submission && submission.state.status !== 'resolved';
    let displayedState = state ?? (isStarting ? 'THINKING' : null);
    if (hasPendingSubmission) displayedState = 'INPUT_REQUIRED';
    if (isLocallyCancelled || streamState === 'CANCELLED') displayedState = null;
    return {
        session: {
            state: displayedState,
            conversationId: conversationId,
            agentIdentity: isStarting ? (0, $4ywyi.getOptimisticCommentAgentIdentity)(commentId) : undefined
        },
        pollingEnabled: pollingEnabled,
        onPollRequest: onPollRequest
    };
}
const $738882cc71046357$var$ignoreSharedSessionPoll = ()=>()=>{};
function $738882cc71046357$export$9d176b0fd4eccbae(commentId, conversationId, initialState) {
    const shared = (0, $cozmU.useContext)((0, $iKgqM.SharedCommentAgentSessionsContext));
    // Shared readers must not create another subscription, outcome reporter or recovery handler.
    const local = $738882cc71046357$export$88d2b52896d57f4(shared ? '' : commentId, shared ? undefined : conversationId, shared ? undefined : initialState);
    const result = shared ? shared.states.get(commentId) ?? {
        session: {
            state: null,
            conversationId: conversationId
        },
        pollingEnabled: false,
        onPollRequest: $738882cc71046357$var$ignoreSharedSessionPoll
    } : local;
    const sessionStatusRef = (0, $ldZ32.useCommentAgentSessionPolling)(result.pollingEnabled, result.onPollRequest);
    return {
        ...result.session,
        sessionStatusRef: sessionStatusRef
    };
}
module.exports["useCommentAgentSessionState"] = $738882cc71046357$export$88d2b52896d57f4;
module.exports["useCommentAgentSession"] = $738882cc71046357$export$9d176b0fd4eccbae;

});

parcelRegister("9ljjX", function(module, exports) {
/**
 * @generated SignedSource<<0ce3c6393f1f3607534b7928d7da7512>>
 * @relayHash 7c992ec15d581cbc0afcf255c8b8cd4f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 01a7d78cb536c8d4d21def834c215f5bfbe84d0eb07a5c6355872d5d30164ab8
const $848ce48367e3d60c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "conversationId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "conversationId",
                    "variableName": "conversationId"
                }
            ],
            "kind": "LinkedField",
            "name": "convoai_onAgentSessionUpdate",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "messageTemplate"
                        }
                    ],
                    "type": "ConvoAiTraceMessage"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "role"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "agentSessionState"
                        },
                        {
                            "concreteType": "ConvoAiAgentAction",
                            "kind": "LinkedField",
                            "name": "actions",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ],
                    "type": "ConvoAiConversationMessage"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": "errorMessageTemplate",
                            "kind": "ScalarField",
                            "name": "messageTemplate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ],
                    "type": "ConvoAiErrorMessage"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCommentAgentSessionStatusSubscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCommentAgentSessionStatusSubscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7c992ec15d581cbc0afcf255c8b8cd4f",
            "id": "01a7d78cb536c8d4d21def834c215f5bfbe84d0eb07a5c6355872d5d30164ab8",
            "metadata": {},
            "name": "useCommentAgentSessionStatusSubscription",
            "operationKind": "subscription",
            "text": "subscription useCommentAgentSessionStatusSubscription($cloudId:ID!,$conversationId:ID!){convoai_onAgentSessionUpdate(cloudId:$cloudId,conversationId:$conversationId)@optIn(to:\"ConvoAiAgentSessionUpdate\"){__typename,...on ConvoAiTraceMessage{messageTemplate},...on ConvoAiConversationMessage{role,agentSessionState,actions{key}},...on ConvoAiErrorMessage{errorMessageTemplate:messageTemplate,statusCode}}}"
        }
    };
}();
$848ce48367e3d60c$var$node.hash = "9ff053c5795e9c184fed44bf12bac377";
var $848ce48367e3d60c$export$2e2bcd8739ae039 = $848ce48367e3d60c$var$node;
module.exports["default"] = $848ce48367e3d60c$export$2e2bcd8739ae039;

});

parcelRegister("ldZ32", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3a1bc = parcelRequire("3a1bc");


var $9vz83 = parcelRequire("9vz83");

function $7fb360f542f72437$export$cd38d355a28fca3e(enabled, onRequest) {
    const scope = (0, $cozmU.useContext)((0, $3a1bc.AgentSessionPollingContext));
    const [element, setElement] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!enabled || !scope || !element) return;
        let stopPolling;
        const observer = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting && !stopPolling) stopPolling = (0, $9vz83.pollCommentAgentSessions)(scope.environment, scope.pageId, onRequest);
            else if (!entry.isIntersecting) {
                stopPolling?.();
                stopPolling = undefined;
            }
        });
        observer.observe(element);
        return ()=>{
            observer.disconnect();
            stopPolling?.();
        };
    }, [
        enabled,
        scope,
        element,
        onRequest
    ]);
    return enabled && scope ? setElement : undefined;
}
module.exports["useCommentAgentSessionPolling"] = $7fb360f542f72437$export$cd38d355a28fca3e;

});

parcelRegister("3a1bc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $6mKj3 = parcelRequire("6mKj3");

const $618d4fd49eb79bc9$export$241c407924b30969 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
function $618d4fd49eb79bc9$var$EnabledPollingProvider({ pageId: pageId, children: children }) {
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const value = (0, $cozmU.useMemo)(()=>({
            environment: environment,
            pageId: pageId
        }), [
        environment,
        pageId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($618d4fd49eb79bc9$export$241c407924b30969.Provider, {
        value: value
    }, children);
}
function $618d4fd49eb79bc9$export$4a03e8c95b8cf236({ pageId: pageId, children: children }) {
    // Keep the legacy tree and Relay requirements unchanged in control.
    if (!(0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($618d4fd49eb79bc9$var$EnabledPollingProvider, {
        pageId: pageId
    }, children);
}
module.exports["AgentSessionPollingContext"] = $618d4fd49eb79bc9$export$241c407924b30969;
module.exports["AgentSessionPollingProvider"] = $618d4fd49eb79bc9$export$4a03e8c95b8cf236;

});

parcelRegister("9vz83", function(module, exports) {

var $6SsN4 = parcelRequire("6SsN4");


var $4bdMj = parcelRequire("4bdMj");


var $cvIm8 = parcelRequire("cvIm8");

const $73dd6671819f3c13$export$6706087e20cdbe44 = 30000;
const $73dd6671819f3c13$var$polls = new WeakMap();
function $73dd6671819f3c13$var$isSessionState(state) {
    return state === 'WORKING' || state === 'INPUT_REQUIRED' || state === 'ARTEFACT_READY' || state === 'FAILED' || state === 'COMPLETED' || state === 'CANCELLED';
}
async function $73dd6671819f3c13$export$988f6174afbe9182(environment, pageId, conversationId) {
    let after = null;
    for(let page = 0; page < (0, $cvIm8.MAX_SESSION_PAGES); page++){
        const data = await (0, $6SsN4.fetchQuery)(environment, (0, $4bdMj.CommentAgentSessionsQuery), {
            pageId: pageId,
            status: [
                'current',
                'draft',
                'archived'
            ],
            first: (0, $cvIm8.SESSION_PAGE_SIZE),
            after: after
        }, {
            fetchPolicy: 'network-only'
        }).toPromise();
        const connection = data?.content?.nodes?.find((node)=>node?.allCommentAgentSessions)?.allCommentAgentSessions;
        if (!connection) return;
        const session = connection.edges?.find((edge)=>edge?.node?.conversationId === conversationId)?.node;
        if ($73dd6671819f3c13$var$isSessionState(session?.agentSession?.state)) return session.agentSession.state;
        const next = connection.pageInfo?.endCursor;
        if (!connection.pageInfo?.hasNextPage || !next || next === after) return;
        after = next;
    }
}
function $73dd6671819f3c13$export$84280be4792ba69e(environment, pageId, listener) {
    const browserDocument = typeof document === 'undefined' ? undefined : document;
    const browserNavigator = typeof navigator === 'undefined' ? undefined : navigator;
    if (!browserDocument || !browserNavigator) return ()=>{};
    let pages = $73dd6671819f3c13$var$polls.get(environment);
    if (!pages) {
        pages = new Map();
        $73dd6671819f3c13$var$polls.set(environment, pages);
    }
    let poll = pages.get(pageId);
    if (!poll) {
        const listeners = new Map();
        let timer;
        let inFlight = false;
        let retryDelay = $73dd6671819f3c13$export$6706087e20cdbe44;
        const canPoll = ()=>listeners.size > 0 && !browserDocument.hidden && browserNavigator.onLine !== false;
        const clearTimer = ()=>{
            clearTimeout(timer);
            timer = undefined;
        };
        const schedule = ()=>{
            clearTimer();
            if (canPoll() && !inFlight) timer = setTimeout(()=>void refresh(), retryDelay);
        };
        const refresh = async ()=>{
            timer = undefined;
            if (!canPoll()) return;
            if ((0, $cvIm8.hasPendingSessionSnapshotRequest)(environment, pageId)) {
                schedule();
                return;
            }
            inFlight = true;
            const receivers = new Map(Array.from(listeners.keys(), (start)=>[
                    start,
                    start()
                ]));
            try {
                let after = null;
                for(let page = 0; page < (0, $cvIm8.MAX_SESSION_PAGES) && canPoll(); page++){
                    // Later discovery requests can share this request without predating its freshness check.
                    const data = await (0, $6SsN4.fetchQuery)(environment, (0, $4bdMj.CommentAgentSessionsQuery), {
                        pageId: pageId,
                        status: [
                            'current',
                            'draft',
                            'archived'
                        ],
                        first: (0, $cvIm8.SESSION_PAGE_SIZE),
                        after: after
                    }, {
                        fetchPolicy: 'network-only'
                    }).toPromise();
                    const connection = data?.content?.nodes?.find((node)=>node?.allCommentAgentSessions)?.allCommentAgentSessions;
                    if (!connection) break;
                    const snapshot = new Map();
                    // At most MAX_SESSION_PAGES pages of SESSION_PAGE_SIZE rows.
                    // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
                    for (const edge of connection.edges ?? []){
                        const session = edge?.node;
                        if (session?.conversationId && $73dd6671819f3c13$var$isSessionState(session.agentSession?.state)) snapshot.set(session.conversationId, session.agentSession.state);
                    }
                    // Notify only mounted, visible consumers for each bounded page.
                    // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
                    for (const [start, receive] of receivers)if (listeners.has(start)) receive(snapshot);
                    const next = connection.pageInfo?.endCursor;
                    if (!connection.pageInfo?.hasNextPage || !next || next === after) break;
                    after = next;
                }
                retryDelay = $73dd6671819f3c13$export$6706087e20cdbe44;
            } catch  {
                // Transport errors leave the current status/proposal intact.
                retryDelay = Math.min(retryDelay * 2, 120000);
            } finally{
                inFlight = false;
                if (listeners.size) schedule();
                else pages?.delete(pageId);
            }
        };
        poll = {
            listeners: listeners,
            resume: ()=>{
                browserDocument.addEventListener('visibilitychange', schedule);
                window.addEventListener('online', schedule);
                window.addEventListener('offline', schedule);
                schedule();
            },
            release: ()=>{
                clearTimer();
                browserDocument.removeEventListener('visibilitychange', schedule);
                window.removeEventListener('online', schedule);
                window.removeEventListener('offline', schedule);
                // Retain a pending request so a quick close/reopen cannot overlap it.
                if (!inFlight) pages?.delete(pageId);
            }
        };
        pages.set(pageId, poll);
    }
    const wasEmpty = poll.listeners.size === 0;
    poll.listeners.set(listener, (poll.listeners.get(listener) ?? 0) + 1);
    if (wasEmpty) poll.resume();
    let released = false;
    return ()=>{
        if (released) return;
        released = true;
        const remaining = (poll.listeners.get(listener) ?? 1) - 1;
        if (remaining) poll.listeners.set(listener, remaining);
        else poll.listeners.delete(listener);
        if (!poll.listeners.size) poll.release();
    };
}
module.exports["fetchCommentAgentSessionState"] = $73dd6671819f3c13$export$988f6174afbe9182;
module.exports["pollCommentAgentSessions"] = $73dd6671819f3c13$export$84280be4792ba69e;

});

parcelRegister("4bdMj", function(module, exports) {

var $fioxx = parcelRequire("fioxx");

const $f539051e975c360c$export$b506abc5596c50d5 = (0, $fioxx.default);
module.exports["CommentAgentSessionsQuery"] = $f539051e975c360c$export$b506abc5596c50d5;

});

parcelRegister("fioxx", function(module, exports) {
/**
 * @generated SignedSource<<f1e82a2d3f24d1147f15503bfc90b50c>>
 * @relayHash c33b19fc9b5e79b8f82605a4e2dafb00
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 452d6a954c3d26e8747c47124eb41c07ae67c7378436fa9f47542c6ca1d74d7c
const $d3972552115b8cca$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "pageId"
        },
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "conversationId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "subEntityId"
    }, v9 = {
        "kind": "ScalarField",
        "name": "state"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v12 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CommentAgentSessionsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "AgentSessionAssociationConnection",
                                    "kind": "LinkedField",
                                    "name": "allCommentAgentSessions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AgentSessionAssociationEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AgentSessionAssociation",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "concreteType": "AgentSession",
                                                            "kind": "LinkedField",
                                                            "name": "agentSession",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "agent",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v10 /*: any*/ ,
                                                                        v11 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v12 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CommentAgentSessionsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "AgentSessionAssociationConnection",
                                    "kind": "LinkedField",
                                    "name": "allCommentAgentSessions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AgentSessionAssociationEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AgentSessionAssociation",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "concreteType": "AgentSession",
                                                            "kind": "LinkedField",
                                                            "name": "agentSession",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "agent",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "__typename"
                                                                        },
                                                                        v5 /*: any*/ ,
                                                                        v10 /*: any*/ ,
                                                                        v11 /*: any*/ 
                                                                    ]
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v12 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "c33b19fc9b5e79b8f82605a4e2dafb00",
            "id": "452d6a954c3d26e8747c47124eb41c07ae67c7378436fa9f47542c6ca1d74d7c",
            "metadata": {},
            "name": "CommentAgentSessionsQuery",
            "operationKind": "query",
            "text": "query CommentAgentSessionsQuery($pageId:ID!,$status:[String!],$first:Int,$after:String){content(id:$pageId,status:$status){nodes{id,allCommentAgentSessions(first:$first,after:$after){edges{node{conversationId,subEntityId,agentSession{state,agent{__typename,id,name,picture},id},id}},pageInfo{hasNextPage,endCursor}}}}}"
        }
    };
}();
$d3972552115b8cca$var$node.hash = "316c6b628135ec5eef7d8b4ca718d73b";
var $d3972552115b8cca$export$2e2bcd8739ae039 = $d3972552115b8cca$var$node;
module.exports["default"] = $d3972552115b8cca$export$2e2bcd8739ae039;

});

parcelRegister("cvIm8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $iIsSm = parcelRequire("iIsSm");


var $6mKj3 = parcelRequire("6mKj3");


var $6FXhW = parcelRequire("6FXhW");


var $gXKuh = parcelRequire("gXKuh");


var $4bdMj = parcelRequire("4bdMj");

const $2a48f77aafd2c021$export$a9d01a6e83b02ecf = [
    2000,
    5000,
    10000
];
// The Content query defaults to current and archived pages when status is omitted. Include drafts
// explicitly so agent session status is also available while editing an unpublished page.
const $2a48f77aafd2c021$var$CONTENT_STATUSES = [
    'current',
    'draft',
    'archived'
];
const $2a48f77aafd2c021$export$9b3454dbad2a1de7 = 100;
const $2a48f77aafd2c021$export$ae3ca1ed0e80075f = 5;
const $2a48f77aafd2c021$var$VALID_CONVERSATION_STATES = new Set([
    'WORKING',
    'ARTEFACT_READY',
    'INPUT_REQUIRED',
    'FAILED'
]);
// Terminal snapshot state the backend reports once the agent has finished its task (the
// ConvoAiAgentSessionState `COMPLETED` value). Per design, a completed session shows NO
// agent-status row, so buildSessionMap skips these sessions entirely (see below).
const $2a48f77aafd2c021$var$COMPLETED_STATE = 'COMPLETED';
const $2a48f77aafd2c021$var$CANCELLED_STATE = 'CANCELLED';
// A continued poll must not adopt an older recovery response after a newer live update.
// Track the existing imperative requests so it can wait for them to settle first.
const $2a48f77aafd2c021$var$pendingSnapshotRequests = new WeakMap();
function $2a48f77aafd2c021$export$529611bd1aa27065(environment, pageId) {
    return ($2a48f77aafd2c021$var$pendingSnapshotRequests.get(environment)?.get(pageId) ?? 0) > 0;
}
function $2a48f77aafd2c021$var$trackSessionSnapshotRequest(environment, pageId) {
    if (!(0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true)) return ()=>{};
    let requests = $2a48f77aafd2c021$var$pendingSnapshotRequests.get(environment);
    if (!requests) {
        requests = new Map();
        $2a48f77aafd2c021$var$pendingSnapshotRequests.set(environment, requests);
    }
    requests.set(pageId, (requests.get(pageId) ?? 0) + 1);
    return ()=>{
        const remaining = (requests.get(pageId) ?? 1) - 1;
        if (remaining) requests.set(pageId, remaining);
        else requests.delete(pageId);
    };
}
// Stable empty value so the initial state keeps referential equality across renders.
const $2a48f77aafd2c021$var$NO_EXTRA_PAGES = [];
/**
 * Reads the sessions connection off the (single) content node of a query response.
 * Returns null when the page or the connection did not resolve.
 */ function $2a48f77aafd2c021$var$readSessionsConnection(data) {
    for (const node of data?.content?.nodes ?? []){
        if (node?.allCommentAgentSessions) return node.allCommentAgentSessions;
    }
    return null;
}
function $2a48f77aafd2c021$var$hasOnlyTerminalSessions(data) {
    const connection = $2a48f77aafd2c021$var$readSessionsConnection(data);
    return connection?.pageInfo?.hasNextPage === false && !!connection.edges?.length && connection.edges.every((edge)=>{
        const state = edge?.node?.agentSession?.state;
        return state === $2a48f77aafd2c021$var$COMPLETED_STATE || state === $2a48f77aafd2c021$var$CANCELLED_STATE && (0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true) || state === 'ARTEFACT_READY' || state === 'FAILED';
    });
}
/**
 * Extracts the numeric comment id from a session's `subEntityId`.
 *
 * `subEntityId` is contracted to be a Confluence comment ARI
 * (`ari:cloud:confluence:<cloudId>:comment/<commentId>`) and the map key must match the
 * `comment.id` used by ObjectComment / ObjectCommentThread. Parsing strictly means a value that
 * is not a comment ARI is dropped rather than contributing a bogus key — the historical
 * "everything after the last slash" rule would turn, say, a page ARI into `<pageId>`, which can
 * collide with a real comment id and attach an agent status row to the wrong comment.
 *
 * Returns null when `subEntityId` is not a well-formed Confluence comment ARI.
 */ function $2a48f77aafd2c021$var$parseCommentIdFromSubEntityId(subEntityId) {
    try {
        return (0, $iIsSm.ConfluenceCommentAri).parse(subEntityId).commentId;
    } catch  {
        // ValidationError — not a Confluence comment ARI.
        return null;
    }
}
/**
 * Pre-guard behaviour: take everything after the last `/`, or the whole string when there is no
 * `/`. Retained verbatim for the experiment-off path so the ungated result is unchanged.
 */ function $2a48f77aafd2c021$var$legacyCommentIdFromSubEntityId(subEntityId) {
    const lastSlash = subEntityId.lastIndexOf('/');
    return lastSlash >= 0 ? subEntityId.slice(lastSlash + 1) : subEntityId;
}
/**
 * Builds a CommentAgentSessionMap from a Relay query result.
 * Pure data transformation — no hooks, no side effects.
 *
 * Unchanged from the pre-paging implementation apart from the gated comment-id extraction below:
 * with both experiments off this produces exactly the same map it always did.
 */ function $2a48f77aafd2c021$var$buildSessionMap(data, conversationMap) {
    const sessionMap = new Map();
    // Resolved once per call rather than per row: this runs on every render of every comment
    // surface, so evaluating the experiment inside the row loop would mean up to
    // SESSION_PAGE_SIZE gate reads per render for no benefit. Cleanup collapses this to
    // `parseCommentIdFromSubEntityId` directly.
    const extractCommentId = (0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true) || (0, $6mKj3.expValEquals)('cc_ai_agentic_sessions', 'isEnabled', true) ? $2a48f77aafd2c021$var$parseCommentIdFromSubEntityId : $2a48f77aafd2c021$var$legacyCommentIdFromSubEntityId;
    // Both loops are bounded: content.nodes is always a single page node, and
    // allCommentAgentSessions is bounded by the number of agent-mentioned comments
    // on the page — a small, user-driven number in practice.
    // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    for (const node of data?.content?.nodes ?? [])// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    for (const edge of node?.allCommentAgentSessions?.edges ?? []){
        const session = edge?.node;
        if (session?.conversationId && session?.subEntityId) {
            // subEntityId format: "ari:cloud:confluence:<cloudId>:comment/<commentId>"
            // Extract the numeric comment ID from the end so map keys match comment.id
            // used in ObjectComment / ObjectCommentThread.
            const commentId = extractCommentId(session.subEntityId);
            if (commentId == null) continue;
            // Keep the source association after completion without reviving its status row.
            conversationMap?.set(commentId, session.conversationId);
            const rawState = session.agentSession?.state;
            // The agent has finished its task (COMPLETED): render no status row at all. Skip the
            // session entirely — keeping it with a null state would fall back to WORKING in
            // useCommentAgentSession and leave a stray connector branch. COMPLETED arrives via
            // this snapshot on page load; useCommentAgentSession handles the equivalent live
            // subscription update after the agent's planned action runs.
            if (rawState === $2a48f77aafd2c021$var$COMPLETED_STATE || rawState === $2a48f77aafd2c021$var$CANCELLED_STATE && (0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true)) continue;
            const agent = session.agentSession?.agent;
            sessionMap.set(commentId, {
                conversationId: session.conversationId,
                state: rawState != null && $2a48f77aafd2c021$var$VALID_CONVERSATION_STATES.has(rawState) ? rawState : null,
                agentId: agent?.id ?? null,
                agentName: agent?.name ?? null,
                avatarUrl: agent?.picture ?? null
            });
        }
    }
    return sessionMap;
}
/**
 * Folds follow-on pages into the map built from page 1, mutating it in place.
 *
 * Only reachable with the experiment on, because `extraPages` is only ever populated by the gated
 * page walk. Pages are applied in server order, so a comment carrying sessions on two different
 * pages resolves last-one-wins — identical to how one un-truncated page would have resolved it.
 */ function $2a48f77aafd2c021$var$mergeFollowOnPages(sessionMap, extraPages, conversationMap) {
    // Bounded by MAX_SESSION_PAGES pages of SESSION_PAGE_SIZE rows.
    // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    for (const page of extraPages)// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    for (const [commentId, session] of $2a48f77aafd2c021$var$buildSessionMap(page, conversationMap))sessionMap.set(commentId, session);
    return sessionMap;
}
/**
 * True only when the server positively reported zero session rows — see
 * `PageCommentAgentSessionsResult.hasConfirmedNoSessions`.
 *
 * Fails safe: an unresolved content node or a null connection (which a partial GraphQL error
 * also produces) is "no answer", not "no sessions", and returns false.
 *
 * Pure: this only reports what the response said. Nothing acts on it unless the experiment is on
 * (see AgentSessionsFetcher), so computing it does not change behaviour on the control path.
 */ function $2a48f77aafd2c021$var$readHasConfirmedNoSessions(data, extraPages) {
    let sawConnection = false;
    // Bounded exactly as in buildSessionMap.
    // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    for (const page of [
        data,
        ...extraPages
    ])// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    for (const node of page?.content?.nodes ?? []){
        const connection = node?.allCommentAgentSessions;
        if (!connection) continue;
        sawConnection = true;
        if ((connection.edges ?? []).length > 0) return false;
    }
    return sawConnection;
}
/**
 * A content signature for page 1 that changes whenever the first page's contents change.
 * Used to decide when the follow-on pages must be re-walked (a refetch that changes page 1
 * invalidates everything after it) without depending on the `data` object identity, which Relay
 * hands back fresh on every store update.
 */ function $2a48f77aafd2c021$var$firstPageSignature(data) {
    const connection = $2a48f77aafd2c021$var$readSessionsConnection(data);
    if (!connection) return 'none';
    const pageInfo = connection.pageInfo;
    return `${(connection.edges ?? []).length}:${pageInfo?.hasNextPage ? '1' : '0'}:${pageInfo?.endCursor ?? ''}`;
}
/**
 * Fetches one follow-on page. Resolves to null when the request fails or yields no payload —
 * paging is best-effort, so a failed page keeps whatever has already been read rather than
 * discarding the first page.
 */ async function $2a48f77aafd2c021$var$fetchSessionsPage(environment, pageId, after) {
    const finishRequest = $2a48f77aafd2c021$var$trackSessionSnapshotRequest(environment, pageId);
    try {
        const data = await (0, $6SsN4.fetchQuery)(environment, (0, $4bdMj.CommentAgentSessionsQuery), {
            pageId: pageId,
            status: $2a48f77aafd2c021$var$CONTENT_STATUSES,
            first: $2a48f77aafd2c021$export$9b3454dbad2a1de7,
            after: after
        }, // New sessions and status changes can land beyond the first page.
        {
            fetchPolicy: (0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true) ? 'network-only' : 'store-or-network'
        }).toPromise();
        return data ?? null;
    } catch  {
        return null;
    } finally{
        finishRequest();
    }
}
function $2a48f77aafd2c021$export$5da222818b77d6d2(pageId, options = {}) {
    const { refetchOnMount: refetchOnMount = false } = options;
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $4bdMj.CommentAgentSessionsQuery), {
        pageId: pageId,
        status: $2a48f77aafd2c021$var$CONTENT_STATUSES,
        // Passed as variables so the query text is gate-independent. When both experiments are off
        // these stay null, which the server treats the same as omitting them — i.e. the default
        // (and maximum) page size of 100, exactly the pre-paging request. Ordered so the
        // experiments are evaluated last.
        first: (0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true) || (0, $6mKj3.expValEquals)('cc_ai_agentic_sessions', 'isEnabled', true) ? $2a48f77aafd2c021$export$9b3454dbad2a1de7 : null,
        after: null
    });
    // Follow-on pages, read imperatively. They are kept out of the Relay-driven `data` above
    // because each page is a separate connection record (distinct `after` argument), so
    // useLazyLoadQuery only ever reads page 1.
    const [extraPages, setExtraPages] = (0, $cozmU.useState)($2a48f77aafd2c021$var$NO_EXTRA_PAGES);
    const [paginationRefresh, setPaginationRefresh] = (0, $cozmU.useState)(0);
    // Close the loop on newly-mentioned agents: when an agent-mention comment is saved
    // (AGENT_MENTION_COMMENT_SAVED_EVENT, also used to open the CwR sidebar), refetch the
    // sessions into the Relay store so the new comment's session connects without a reload.
    // fetchQuery updates the store imperatively and useLazyLoadQuery re-reads it reactively,
    // so this never re-suspends or blanks the comment UI. We poll a few bounded times to
    // absorb the backend's async creation of the SessionAssociationPublic.
    const refetchTimersRef = (0, $cozmU.useRef)([]);
    const clearRefetchTimers = (0, $cozmU.useCallback)(()=>{
        refetchTimersRef.current.forEach(clearTimeout);
        refetchTimersRef.current = [];
    }, []);
    const scheduleSessionRefetches = (0, $cozmU.useCallback)(()=>{
        // Supersede any in-flight poll from a previous save so timers don't pile up.
        clearRefetchTimers();
        // Keep checking beyond session creation when live updates are unavailable.
        const delays = (0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true) ? [
            ...$2a48f77aafd2c021$export$a9d01a6e83b02ecf,
            15000,
            20000,
            30000
        ] : $2a48f77aafd2c021$export$a9d01a6e83b02ecf;
        const timers = delays.map((delay)=>setTimeout(()=>{
                let finishRequest = ()=>{};
                (0, $6SsN4.fetchQuery)(environment, (0, $4bdMj.CommentAgentSessionsQuery), {
                    pageId: pageId,
                    status: $2a48f77aafd2c021$var$CONTENT_STATUSES,
                    first: (0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true) || (0, $6mKj3.expValEquals)('cc_ai_agentic_sessions', 'isEnabled', true) ? $2a48f77aafd2c021$export$9b3454dbad2a1de7 : null,
                    after: null
                }, {
                    fetchPolicy: 'network-only'
                }).subscribe({
                    start: ()=>{
                        finishRequest = $2a48f77aafd2c021$var$trackSessionSnapshotRequest(environment, pageId);
                    },
                    complete: ()=>finishRequest(),
                    next: (response)=>{
                        if (refetchTimersRef.current === timers && (0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true)) setPaginationRefresh((version)=>version + 1);
                        // Preserve the initial discovery window. Only a complete, non-empty
                        // page of terminal sessions can end the remaining recovery checks.
                        if (delay >= Math.max(...$2a48f77aafd2c021$export$a9d01a6e83b02ecf) && refetchTimersRef.current === timers && $2a48f77aafd2c021$var$hasOnlyTerminalSessions(response) && (0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true)) clearRefetchTimers();
                    },
                    error: ()=>finishRequest()
                });
            }, delay));
        refetchTimersRef.current = timers;
    }, [
        clearRefetchTimers,
        environment,
        pageId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!refetchOnMount) return;
        scheduleSessionRefetches();
        return clearRefetchTimers;
    }, [
        clearRefetchTimers,
        refetchOnMount,
        scheduleSessionRefetches
    ]);
    (0, $cozmU.useEffect)(()=>{
        window.addEventListener((0, $gXKuh.AGENT_MENTION_COMMENT_SAVED_EVENT), scheduleSessionRefetches);
        window.addEventListener((0, $gXKuh.AGENT_SESSION_SUBSCRIPTION_FAILED_EVENT), scheduleSessionRefetches);
        window.addEventListener((0, $gXKuh.BACKGROUND_CONVERSATION_ACTIONS_RECONCILE_EVENT), scheduleSessionRefetches);
        return ()=>{
            window.removeEventListener((0, $gXKuh.AGENT_MENTION_COMMENT_SAVED_EVENT), scheduleSessionRefetches);
            window.removeEventListener((0, $gXKuh.AGENT_SESSION_SUBSCRIPTION_FAILED_EVENT), scheduleSessionRefetches);
            window.removeEventListener((0, $gXKuh.BACKGROUND_CONVERSATION_ACTIONS_RECONCILE_EVENT), scheduleSessionRefetches);
            clearRefetchTimers();
        };
    }, [
        clearRefetchTimers,
        scheduleSessionRefetches
    ]);
    // Key the walk on page one's shape rather than object identity, so unrelated store updates
    // do not restart it. The gated refresh counter also restarts it after discovery polls.
    // Without a poll or a changed first-page signature, later-page additions still wait for
    // another walk (for example, on remount).
    const pageOneSignature = $2a48f77aafd2c021$var$firstPageSignature(data);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true)) // A changed first page invalidates later pages; a poll alone keeps them visible.
        setExtraPages((prev)=>prev.length > 0 ? $2a48f77aafd2c021$var$NO_EXTRA_PAGES : prev);
    }, [
        environment,
        pageId,
        pageOneSignature
    ]);
    // Refresh later pages after polling even when page one's cursors have not changed.
    // Keep the previous results visible while refreshing the same connection.
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true)) // Preserve the original reset-and-fetch effect in control. Returning prev avoids an
        // extra render when there are no follow-on pages to clear.
        setExtraPages((prev)=>prev.length > 0 ? $2a48f77aafd2c021$var$NO_EXTRA_PAGES : prev);
        const connection = $2a48f77aafd2c021$var$readSessionsConnection(data);
        const firstCursor = connection?.pageInfo?.endCursor;
        // Evaluate the paging experiments last: only expose them for a truncated first page.
        if (!connection?.pageInfo?.hasNextPage || !firstCursor || !((0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true) || (0, $6mKj3.expValEquals)('cc_ai_agentic_sessions', 'isEnabled', true))) return;
        let cancelled = false;
        (async ()=>{
            const pages = [];
            let after = firstCursor;
            // -1 because page 1 came from useLazyLoadQuery and already counts against the cap.
            for(let i = 0; i < $2a48f77aafd2c021$export$ae3ca1ed0e80075f - 1; i++){
                if (cancelled || after == null) break;
                const page = await $2a48f77aafd2c021$var$fetchSessionsPage(environment, pageId, after);
                if (cancelled || page == null) break;
                pages.push(page);
                const nextPageInfo = $2a48f77aafd2c021$var$readSessionsConnection(page)?.pageInfo;
                // Stop unless the server both reports more rows and hands back a cursor that
                // actually advanced — a repeated cursor would otherwise re-read the same page.
                const nextCursor = nextPageInfo?.endCursor;
                after = nextPageInfo?.hasNextPage && nextCursor && nextCursor !== after ? nextCursor : null;
            }
            if (!cancelled && pages.length > 0) setExtraPages(pages);
        })();
        return ()=>{
            cancelled = true;
        };
    // `data` is read for its contents only, and those are captured by pageOneSignature; using
    // `data` itself as a dep would restart the walk on every unrelated store update.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        environment,
        pageId,
        pageOneSignature,
        paginationRefresh
    ]);
    // With both experiments off, the walk never runs and extraPages stays empty.
    const conversationMap = new Map();
    const chatConversations = (0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true) ? conversationMap : undefined;
    const sessionMap = $2a48f77aafd2c021$var$buildSessionMap(data, chatConversations);
    return {
        sessionMap: extraPages.length > 0 ? $2a48f77aafd2c021$var$mergeFollowOnPages(sessionMap, extraPages, chatConversations) : sessionMap,
        conversationMap: conversationMap,
        hasConfirmedNoSessions: $2a48f77aafd2c021$var$readHasConfirmedNoSessions(data, extraPages)
    };
}
function $2a48f77aafd2c021$export$fd2a40a7613a5378() {
    // When experiment is off, return immediately — zero queries, zero Suspense.
    // AgentSessionsFetcher (the component that calls useLazyLoadQuery) is never
    // mounted in ObjectCommentContainer when the gate is off, so this context
    // will always be the default empty Map in that case.
    return (0, $6FXhW.useAgentSessionsContext)();
}
module.exports["SESSION_REFETCH_DELAYS_MS"] = $2a48f77aafd2c021$export$a9d01a6e83b02ecf;
module.exports["SESSION_PAGE_SIZE"] = $2a48f77aafd2c021$export$9b3454dbad2a1de7;
module.exports["MAX_SESSION_PAGES"] = $2a48f77aafd2c021$export$ae3ca1ed0e80075f;
module.exports["hasPendingSessionSnapshotRequest"] = $2a48f77aafd2c021$export$529611bd1aa27065;
module.exports["usePageCommentAgentSessionsInner"] = $2a48f77aafd2c021$export$5da222818b77d6d2;

});

parcelRegister("iKgqM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $c4cd451518328047$export$eeb31cfae8b00656 = (0, $cozmU.createContext)(null);
const $c4cd451518328047$var$EMPTY_SNAPSHOT = {
    sessionMap: new Map(),
    conversationMap: new Map(),
    states: new Map()
};
let $c4cd451518328047$var$stores = new WeakMap();
function $c4cd451518328047$export$e7dd8e401c9ff9c8(environment, cloudId, userId, contentId) {
    let scopedStores = $c4cd451518328047$var$stores.get(environment);
    if (!scopedStores) {
        scopedStores = new Map();
        $c4cd451518328047$var$stores.set(environment, scopedStores);
    }
    const scopeStores = scopedStores;
    const key = JSON.stringify([
        cloudId,
        userId,
        contentId
    ]);
    const existing = scopeStores.get(key);
    if (existing) return existing;
    let snapshot = $c4cd451518328047$var$EMPTY_SNAPSHOT;
    let owners = 0;
    const listeners = new Set();
    const releaseUnusedStore = ()=>{
        // Effect replay and a panel mounting in another branch can retain this scope synchronously.
        queueMicrotask(()=>{
            if (owners === 0 && listeners.size === 0 && scopeStores.get(key) === store) scopeStores.delete(key);
        });
    };
    const publish = (next)=>{
        if (snapshot === next) return;
        snapshot = next;
        for (const listener of listeners)listener();
    };
    const store = {
        getSnapshot: ()=>snapshot,
        subscribe: (listener)=>{
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
                releaseUnusedStore();
            };
        },
        publish: publish,
        retainOwner: ()=>{
            owners += 1;
            let released = false;
            return ()=>{
                if (released) return;
                released = true;
                owners -= 1;
                if (owners === 0) publish($c4cd451518328047$var$EMPTY_SNAPSHOT);
                releaseUnusedStore();
            };
        }
    };
    scopeStores.set(key, store);
    return store;
}
function $c4cd451518328047$export$6a4ad03a48848d8b() {
    $c4cd451518328047$var$stores = new WeakMap();
}
module.exports["SharedCommentAgentSessionsContext"] = $c4cd451518328047$export$eeb31cfae8b00656;
module.exports["getSharedCommentAgentSessions"] = $c4cd451518328047$export$e7dd8e401c9ff9c8;

});


//# sourceMappingURL=MediaViewerCommentSidebar.12800a7f.js.map
